import { AbstractControl, ValidatorFn } from '@angular/forms';

export function iso2CountryValidator(): ValidatorFn {
    return (control: AbstractControl): { [key: string]: any } | null => {
        if (!control.value) {
            return null;
        }
        const iso2CountryPattern = /^[A-Za-z]{2}$/;
        const isValid: boolean = iso2CountryPattern.test(control.value);

        return isValid ? null : {'invalidIso2Country': {value: control.value}};
    };
}

export function nonNumericValidator(): ValidatorFn {
    return (control: AbstractControl): { [key: string]: any } | null => {
        if (!control.value) {
            return null;
        }
        const nonNumericPattern = /^[^\d]*$/;

        if (nonNumericPattern.test(control.value)) {
            return null;
        } else {
            return {'containsNumeric': {value: control.value}};
        }
    };
}
